import { render, staticRenderFns } from "./OrderBy.vue?vue&type=template&id=07f32bd0&"
import script from "./OrderBy.vue?vue&type=script&lang=js&"
export * from "./OrderBy.vue?vue&type=script&lang=js&"
import style0 from "./OrderBy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports